<app-si-dialog [hideHeader]="true" saveButtonText="Reconnect" modalFooterClasses="si-dialog__footer--centered" (save)="onReconnect()">
    <ng-template appDialogBody>
        <div class="px-16 py-8">
            <div class="flex items-start gap-5">
                <fa-icon class="text-primary-light shrink-0 mt-0.5" [icon]="['fal', 'circle-exclamation']" size="2x"></fa-icon>
                <div>
                    <h3 class="m-0">Credentials Invalid</h3>
                    <p class="mt-2 mb-0">Your connection with {{provider.split('_')[0] | titlecase}} has expired. Please reconnect your account to export
                    contacts to {{provider.split('_')[0]| titlecase}} again.</p>
                </div>
            </div>
        </div>
    </ng-template>
</app-si-dialog>
